import { render, staticRenderFns } from "./newUserRecommend.vue?vue&type=template&id=3e0621be&scoped=true"
import script from "./newUserRecommend.vue?vue&type=script&lang=js"
export * from "./newUserRecommend.vue?vue&type=script&lang=js"
import style0 from "./newUserRecommend.vue?vue&type=style&index=0&id=3e0621be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0621be",
  null
  
)

export default component.exports